export default {"src":"/_next/static/media/poppy.a27fc43e.svg","height":168,"width":139,"blurWidth":0,"blurHeight":0};